import { render } from "./Setor.vue?vue&type=template&id=d5888386&scoped=true"
import script from "./Setor.vue?vue&type=script&lang=js"
export * from "./Setor.vue?vue&type=script&lang=js"

import "./Setor.vue?vue&type=style&index=0&id=d5888386&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5888386"]])

export default __exports__